// Which site this build produces. Set at build time via VITE_SITE.
export const SITE_KEYS = ["navimumbai", "pune", "bangalore", "shirdi"];

const requested = import.meta.env.VITE_SITE || "navimumbai";

if (!SITE_KEYS.includes(requested)) {
  throw new Error(
    `Invalid VITE_SITE "${requested}". Use one of: ${SITE_KEYS.join(", ")}`
  );
}

export const SITE_KEY = requested;

export const SITE_ORIGINS = {
  navimumbai: "https://hairclinique.in",
  pune: "https://pune.hairclinique.in",
  bangalore: "https://bangalore.hairclinique.in",
  shirdi: "https://shirdi.hairclinique.in",
};

export const SITE_ORIGIN = SITE_ORIGINS[SITE_KEY];